module.exports = __webpack_public_path__ + "static/media/reversals.778cb7bd.jpg";